export default __webpack_public_path__ + "static/media/fish.997f4c2e.png";